'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

module.exports = require('promise');


//////////////////
// WEBPACK FOOTER
// /~/fbjs/lib/Promise.js
// module id = 41KF
// module chunks = 0